import { IEsteira, IEsteiraDetalhe, IImportacao } from "../interfaces/IEsteira";
import api from "./Api";

class EsteiraNovaService {
    async buscarPorEmpresa(empresaID: number): Promise<IEsteira[]> {
        const { data: result } = await api.get<IEsteira[]>(`v2/Esteira/Empresa/${empresaID}`);

        return result;
    }

    async buscar(): Promise<IEsteira[]> {
        const { data: result } = await api.get<IEsteira[]>('v2/Esteira');

        return result;
    }

    async buscarPorId(id: number): Promise<IEsteira> {
        const { data: result } = await api.get<IEsteira>(`v2/Esteira/${id}`);

        return result;
    }

    async buscarDetalhe(id: number): Promise<IEsteiraDetalhe> {
        const { data } = await api.get<IEsteiraDetalhe>(`Esteira/${id}`);
        return data;
    }

    async buscarTodasPorEmpresa(empresaID: number): Promise<IImportacao[]> {
        const { data: result } = await api.get<IImportacao[]>(`esteira/empresa/${empresaID}/all`, {
            baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
        });

        return result;
    }
}


export default new EsteiraNovaService();